const showHideIcon = $('#show-hide-icon');
const inputPassword = $('#password');
const icon = $('#icon');

/**
 * Aplicando o listeners do icone de mostrar a senha
 */
function HandleShowPassword() {
  showHideIcon.on('click', function (event) {
    event.preventDefault();

    if (inputPassword.attr('type') == 'text') {
      inputPassword.attr('type', 'password');
      icon.addClass('fa-eye-slash');
      icon.removeClass('fa-eye');
    } else if (inputPassword.attr('type') == 'password') {
      inputPassword.attr('type', 'text');
      icon.removeClass('fa-eye-slash');
      icon.addClass('fa-eye');
    }
  });
}

exports.init = HandleShowPassword;
